<div #header class="sg-header" [ngClass]="{ 'sg-scrolled': scrolled }">

    <!-- ===== TOP BAR ===== -->
    <div class="sg-topbar">
        <div class="sg-container sg-topbar-inner">
            <div class="sg-topbar-left">
                <span>Local Galapagos DMC in Ecuador</span>
                <span class="sg-dot">&bull;</span>
                <span>TripAdvisor Travellers' Choice 2022-2026</span>
            </div>
            <div class="sg-topbar-right">
                <a href="tel:+593984059770" class="sg-topbar-link">
                    <svg class="sg-ic sg-ic-sm" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                    </svg>
                    <span>+593 984059770</span>
                </a>
                <a href="mailto:travel&#64;smartgalapagos.com" class="sg-topbar-link sg-mail-link">
                    <svg class="sg-ic sg-ic-sm" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                        <rect width="20" height="16" x="2" y="4" rx="2" />
                        <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
                    </svg>
                    <span>travel&#64;smartgalapagos.com</span>
                </a>
                <a href="https://wa.me/593984059770" target="_blank" rel="noopener noreferrer" class="sg-wa-pill">
                    <svg class="sg-ic sg-ic-sm" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                        <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />
                    </svg>
                    <span>WhatsApp</span>
                </a>
            </div>
        </div>
    </div>

    <!-- ===== MAIN BAR ===== -->
    <div>
        <div class="sg-container sg-bar-inner">
            <a href="https://www.smartgalapagos.com/" target="_blank" rel="noopener noreferrer" class="sg-logo"
                aria-label="Smart Galapagos">
                <img src="assets/images/logos-header/smg.webp" alt="Smart Galapagos" />
            </a>

            <nav class="sg-nav" aria-label="Main navigation">

                <!-- Island Hopping -->
                <a href="https://www.smartgalapagos.com/island-hopping" target="_blank"
                    class="sg-nav-btn sg-nav-link">
                    Island Hopping
                    <svg class="sg-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                        <path d="m6 9 6 6 6-6" />
                    </svg>
                </a>

                <!-- Cruises -->
                <a href="https://www.smartgalapagos.com/cruises" target="_blank" class="sg-nav-btn sg-nav-link">
                    Cruises
                    <svg class="sg-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                        <path d="m6 9 6 6 6-6" />
                    </svg>
                </a>

                <!-- Experiences -->
                <a href="https://www.smartgalapagos.com/adventure" target="_blank"
                    class="sg-nav-btn sg-nav-link">
                    Experiences
                    <svg class="sg-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                        <path d="m6 9 6 6 6-6" />
                    </svg>
                </a>

                <!-- About Galapagos -->
                <a href="https://www.smartgalapagos.com/about-galapagos/animals" target="_blank"
                    class="sg-nav-btn sg-nav-link">
                    About Galapagos
                    <svg class="sg-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                        <path d="m6 9 6 6 6-6" />
                    </svg>
                </a>

                <a href="https://www.smartgalapagos.com/other-destinations" target="_blank" class="sg-nav-link">Other
                    Destinations</a>
            </nav>

            <div class="sg-actions">
                <div class="sg-wishlist" *ngIf="companyParamsService.getFiltersInterest()">
                    <app-heart-header></app-heart-header>
                </div>
                <a href="https://www.smartgalapagos.com/contact-us" target="_blank" class="sg-cta">PLAN YOUR TRIP</a>
            </div>

            <button type="button" class="sg-burger" (click)="renderMenu()" [attr.aria-expanded]="showMenu"
                aria-label="Open navigation menu">
                <svg *ngIf="!showMenu" class="sg-ic sg-ic-lg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <line x1="4" x2="20" y1="12" y2="12" />
                    <line x1="4" x2="20" y1="6" y2="6" />
                    <line x1="4" x2="20" y1="18" y2="18" />
                </svg>
                <svg *ngIf="showMenu" class="sg-ic sg-ic-lg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M18 6 6 18" />
                    <path d="m6 6 12 12" />
                </svg>
            </button>
        </div>
    </div>

    <!-- ===== MOBILE PANEL ===== -->
    <div class="sg-mobile" [ngClass]="{ 'sg-mobile-open': showMenu }">
        <nav class="sg-mobile-nav" aria-label="Mobile navigation">

            <div class="sg-acc" [ngClass]="{ 'sg-acc-open': openAccordion === 'island' }">
                <button type="button" class="sg-acc-head" (click)="toggleAccordion('island')"
                    [attr.aria-expanded]="openAccordion === 'island'">
                    Island Hopping
                    <svg class="sg-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                        <path d="m6 9 6 6 6-6" />
                    </svg>
                </button>
                <div class="sg-acc-body">
                    <a href="https://www.smartgalapagos.com/island-hopping" target="_blank"
                        class="sg-acc-link">View All Island Hopping</a>
                    <a href="https://www.smartgalapagos.com/island-hopping/essential" target="_blank"
                        class="sg-acc-link">Essential Island Hopping</a>
                    <a href="https://www.smartgalapagos.com/island-hopping/ideal" target="_blank"
                        class="sg-acc-link">Ideal Island Hopping</a>
                    <a href="https://www.smartgalapagos.com/island-hopping/superior" target="_blank"
                        class="sg-acc-link">Superior Island Hopping</a>
                    <a href="https://www.smartgalapagos.com/island-hopping/luxury" target="_blank"
                        class="sg-acc-link">Luxury Island Hopping</a>
                </div>
            </div>

            <div class="sg-acc" [ngClass]="{ 'sg-acc-open': openAccordion === 'cruises' }">
                <button type="button" class="sg-acc-head" (click)="toggleAccordion('cruises')"
                    [attr.aria-expanded]="openAccordion === 'cruises'">
                    Cruises
                    <svg class="sg-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                        <path d="m6 9 6 6 6-6" />
                    </svg>
                </button>
                <div class="sg-acc-body">
                    <a href="https://www.smartgalapagos.com/cruises" target="_blank" class="sg-acc-link">View All
                        Cruises</a>
                    <a href="https://www.smartgalapagos.com/cruises#last-minute" target="_blank"
                        class="sg-acc-link sg-link-red">Last Minute</a>
                    <a href="https://www.smartgalapagos.com/cruises/mid-range" target="_blank"
                        class="sg-acc-link">Mid-range Cruises</a>
                    <a href="https://www.smartgalapagos.com/cruises/tourist-superior" target="_blank"
                        class="sg-acc-link">Tourist Superior Cruises</a>
                    <a href="https://www.smartgalapagos.com/cruises/first-class" target="_blank"
                        class="sg-acc-link">First Class Cruises</a>
                    <a href="https://www.smartgalapagos.com/cruises/premium" target="_blank"
                        class="sg-acc-link">Premium Cruises</a>
                    <a href="https://www.smartgalapagos.com/cruises/luxury" target="_blank" class="sg-acc-link">Luxury
                        Cruises</a>
                </div>
            </div>

            <div class="sg-acc" [ngClass]="{ 'sg-acc-open': openAccordion === 'experiences' }">
                <button type="button" class="sg-acc-head" (click)="toggleAccordion('experiences')"
                    [attr.aria-expanded]="openAccordion === 'experiences'">
                    Experiences
                    <svg class="sg-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                        <path d="m6 9 6 6 6-6" />
                    </svg>
                </button>
                <div class="sg-acc-body">
                    <a href="https://www.smartgalapagos.com/adventure" target="_blank"
                        class="sg-acc-link">Adventure</a>
                    <a href="https://www.smartgalapagos.com/family" target="_blank" class="sg-acc-link">Family</a>
                    <a href="https://www.smartgalapagos.com/couple" target="_blank" class="sg-acc-link">Couple</a>
                    <a href="https://www.smartgalapagos.com/diving" target="_blank" class="sg-acc-link">Diving</a>
                    <a href="https://www.smartgalapagos.com/luxury" target="_blank" class="sg-acc-link">Luxury</a>
                </div>
            </div>

            <div class="sg-acc" [ngClass]="{ 'sg-acc-open': openAccordion === 'about' }">
                <button type="button" class="sg-acc-head" (click)="toggleAccordion('about')"
                    [attr.aria-expanded]="openAccordion === 'about'">
                    About Galapagos
                    <svg class="sg-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                        <path d="m6 9 6 6 6-6" />
                    </svg>
                </button>
                <div class="sg-acc-body">
                    <a href="https://www.smartgalapagos.com/about-galapagos/animals" target="_blank"
                        class="sg-acc-link">Animals</a>
                    <a href="https://www.smartgalapagos.com/about-galapagos/islands" target="_blank"
                        class="sg-acc-link">Islands</a>
                    <a href="https://www.smartgalapagos.com/about-galapagos/destinations" target="_blank"
                        class="sg-acc-link">Destinations</a>
                    <a href="https://www.smartgalapagos.com/about-galapagos/weather" target="_blank"
                        class="sg-acc-link">Weather</a>
                    <a href="https://www.smartgalapagos.com/about-galapagos/month-by-month" target="_blank"
                        class="sg-acc-link">Month by Month</a>
                    <a href="https://www.smartgalapagos.com/about-galapagos/island-hopping-vs-cruises"
                        target="_blank" class="sg-acc-link">Island Hopping vs Cruises</a>
                    <p class="sg-acc-heading">Travel Guides</p>
                    <a href="https://www.smartgalapagos.com/blog/travel-planning" target="_blank"
                        class="sg-acc-link">Travel Planning</a>
                    <a href="https://www.smartgalapagos.com/blog/islands-destinations" target="_blank"
                        class="sg-acc-link">Islands &amp; Destinations</a>
                    <a href="https://www.smartgalapagos.com/blog/cruises-island-hopping" target="_blank"
                        class="sg-acc-link">Cruises &amp; Island Hopping</a>
                    <a href="https://www.smartgalapagos.com/blog/wildlife-nature" target="_blank"
                        class="sg-acc-link">Wildlife &amp; Nature</a>
                    <a href="https://www.smartgalapagos.com/blog/things-to-do" target="_blank"
                        class="sg-acc-link">Things to Do</a>
                    <p class="sg-acc-heading">Travel Experiences</p>
                    <a href="https://www.smartgalapagos.com/blog/travel-experiences/adventure" target="_blank"
                        class="sg-acc-link">Adventure</a>
                    <a href="https://www.smartgalapagos.com/blog/travel-experiences/family" target="_blank"
                        class="sg-acc-link">Family</a>
                    <a href="https://www.smartgalapagos.com/blog/travel-experiences/couple" target="_blank"
                        class="sg-acc-link">Couple</a>
                    <a href="https://www.smartgalapagos.com/blog/travel-experiences/diving" target="_blank"
                        class="sg-acc-link">Diving</a>
                    <a href="https://www.smartgalapagos.com/blog/travel-experiences/luxury" target="_blank"
                        class="sg-acc-link">Luxury</a>
                    <a href="https://www.smartgalapagos.com/why-smart-galapagos" target="_blank"
                        class="sg-acc-link">Why Smart Galapagos</a>
                    <a href="https://www.smartgalapagos.com/galapagos-faqs" target="_blank"
                        class="sg-acc-link">Galapagos FAQs</a>
                </div>
            </div>

            <a href="https://www.smartgalapagos.com/other-destinations" target="_blank"
                class="sg-mobile-link">Other Destinations</a>

            <div class="sg-wishlist sg-wishlist-mobile" *ngIf="companyParamsService.getFiltersInterest()">
                <app-heart-header></app-heart-header>
            </div>

            <a href="https://www.smartgalapagos.com/contact-us" target="_blank" class="sg-cta sg-cta-mobile">PLAN YOUR
                TRIP</a>
        </nav>

        <div class="sg-contacts">
            <a href="tel:+593984059770" class="sg-contact-link">
                <svg class="sg-ic sg-ic-sm" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path
                        d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
                <span>+593 984059770</span>
            </a>
            <a href="mailto:travel&#64;smartgalapagos.com" class="sg-contact-link">
                <svg class="sg-ic sg-ic-sm" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <rect width="20" height="16" x="2" y="4" rx="2" />
                    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
                </svg>
                <span>travel&#64;smartgalapagos.com</span>
            </a>
            <a href="https://wa.me/593984059770" target="_blank" rel="noopener noreferrer" class="sg-wa-pill">
                <svg class="sg-ic sg-ic-sm" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />
                </svg>
                <span>WhatsApp</span>
            </a>
        </div>
    </div>
</div>
